import React, { useState } from 'react';
import { useSignupForm } from '../hooks/useSignupForm';
import { trackGigSelection } from '../utils/analytics';

const VelvetRopeForm = () => {
  const [selectedGig, setSelectedGig] = useState('');
  const {
    formData,
    errors,
    isSubmitting,
    submitStatus,
    handleChange,
    handleSubmit,
  } = useSignupForm();

  const handleFormSubmit = (e) => {
    e.preventDefault();
    // Pass the gig selection as additional data and form name for analytics
    handleSubmit(e, { selected_gig: selectedGig }, 'Velvet Rope Form');
  };

  const gigOptions = [
    "The Crooks (Jan '26)",
    "Stigmata presents cold in Berlin (Jan '26)",
    "Beau Anderson with Hypnogator and Neon Black (Apr '26)",
    "Just browsing",
  ];

  if (submitStatus === 'success') {
    return (
      <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 border-2 border-[#4ADE80] shadow-2xl max-w-md w-full">
        <div className="text-center space-y-4">
          <div className="w-16 h-16 bg-[#4ADE80] rounded-full flex items-center justify-center mx-auto">
            <svg className="w-8 h-8 text-[#050505]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h3 className="text-2xl font-bold text-white">Welcome to the Squad!</h3>
          <p className="text-gray-300">
            You're on the waitlist! We'll be in touch soon with your Founding Member access.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 border-2 border-gray-700 shadow-2xl max-w-md w-full">
      <div className="space-y-6">
        <div className="text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-2">
            Reserve Your Spot
          </h2>
          <div className="w-16 h-1 bg-[#4ADE80] mx-auto rounded-full"></div>
        </div>

        <form onSubmit={handleFormSubmit} className="space-y-5">
          {/* Ghost Handle Field */}
          <div>
            <label htmlFor="name" className="block text-sm font-semibold text-gray-300 mb-2">
              Choose Your Ghost Handle
            </label>
            <div className="relative">
              <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">@</span>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="MusicFan99"
                className="w-full pl-8 pr-4 py-3 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#4ADE80] focus:border-transparent transition-all"
                required
                disabled={isSubmitting}
              />
            </div>
            {errors.name && (
              <p className="mt-1 text-sm text-red-400">{errors.name}</p>
            )}
          </div>

          {/* Email Field */}
          <div>
            <label htmlFor="email" className="block text-sm font-semibold text-gray-300 mb-2">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email_address"
              value={formData.email_address}
              onChange={handleChange}
              placeholder="your.email@example.com"
                className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#4ADE80] focus:border-transparent transition-all"
              required
              disabled={isSubmitting}
            />
            {errors.email_address && (
              <p className="mt-1 text-sm text-red-400">{errors.email_address}</p>
            )}
          </div>

          {/* Gig Dropdown */}
          <div>
            <label htmlFor="gig" className="block text-sm font-semibold text-gray-300 mb-2">
              Which gig are you eyeing up?
            </label>
            <div className="relative">
              <select
                id="gig"
                value={selectedGig}
                onChange={(e) => {
                  const gigValue = e.target.value;
                  setSelectedGig(gigValue);
                  if (gigValue) {
                    trackGigSelection(gigValue);
                  }
                }}
                className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg text-white appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#4ADE80] focus:border-transparent transition-all pr-10"
                required
                disabled={isSubmitting}
              >
                <option value="" className="bg-gray-800 text-gray-400">Select a gig...</option>
                {gigOptions.map((gig, index) => (
                  <option key={index} value={gig} className="bg-gray-800 text-white">
                    {gig}
                  </option>
                ))}
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-[#4ADE80] text-[#050505] font-bold py-4 px-6 rounded-lg hover:bg-[#3dd16f] hover:shadow-lg hover:shadow-[#4ADE80]/50 transform hover:-translate-y-0.5 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
          >
            {isSubmitting ? 'Claiming...' : 'Claim Founding Member Status'}
          </button>

          {/* Micro-copy */}
          <p className="text-xs text-gray-400 text-center">
            Limited to first 500 users. No spam, just squads.
          </p>

          {errors.submit && (
            <div className="bg-red-900/50 border border-red-700 rounded-lg p-3 text-red-300 text-sm text-center">
              {errors.submit}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default VelvetRopeForm;
